import { bscChainId, ethChainId } from '@/utils/contract/chainId';
import { useEffect, useState } from 'react';
import { useChainId, useSwitchChain } from 'wagmi';

export const useSwitchChainId = (network: string) => {
  const [isChainShouldbeSwitched, setChainShouldbeSwitched] = useState(false);
  const [isChainSwitching, setChainSwithing] = useState(false);
  const isEthNetwork = network === 'ETH';
  const isBscNetwork = network === 'BSC';

  const switchChain = useSwitchChain();
  const chainId = useChainId();

  useEffect(() => {
    if (!network) return;

    if (isBscNetwork && chainId !== +bscChainId) {
      setChainShouldbeSwitched(true);
    }
    if (isEthNetwork && chainId !== +ethChainId) {
      setChainShouldbeSwitched(true);
    }
  }, [network]);

  const handleSwithChainId = async () => {
    if (!isChainShouldbeSwitched) return;
    setChainSwithing(true);
    if (isEthNetwork) {
      await switchChain.switchChainAsync({
        chainId: +ethChainId,
      });
    } else if (isBscNetwork) {
      await switchChain.switchChainAsync({
        chainId: +bscChainId,
      });
    }
    setChainShouldbeSwitched(false);
    setChainSwithing(false);
  };

  return {
    handleSwithChainId,
    chainId,
    isChainSwitching,
  };
};
